import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Dialog } from "@headlessui/react";
import { PitchContext } from "../context/PitchContex";

function Register() {
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("5");
  const [city, setCity] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [role, setRole] = useState("user");
  // New admin-specific states
  const [subMerchantType, setSubMerchantType] = useState("");
  const [iban, setIban] = useState("");
  const [identityNumber, setIdentityNumber] = useState("");
  const [taxNumber, setTaxNumber] = useState("");
  const [acceptedKvkk, setAcceptedKvkk] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showKvkkModal, setShowKvkkModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  const {
    backendURL,
    navigate,
    setShowAlert,
    setAlertMessage,
    setPending,
    setIsErr,
  } = useContext(PitchContext);

  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    let formatted = digits.slice(0, 10);
    if (digits.length > 3) {
      formatted = `${digits.slice(0, 3)} ${digits.slice(3)}`;
    }
    if (digits.length > 6) {
      formatted = `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(
        6
      )}`;
    }
    return formatted;
  };

  const handlePhoneChange = (e) => {
    const input = e.target.value;
    const formattedPhone = formatPhoneNumber(input);
    setPhone(formattedPhone);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!acceptedKvkk || !acceptedTerms) {
      setIsErr(true);
      setAlertMessage(
        "Kayıt olabilmek için tüm sözleşmeleri kabul etmelisiniz."
      );
      setShowAlert(true);
      return;
    }
    if (password !== confirmPassword) {
      setIsErr(true);
      setAlertMessage("Şifreler eşleşmiyor!");
      setShowAlert(true);
      return;
    }
    setPending((prev) => !prev);
    const phoneForSubmission = phone.replace(/\s/g, "");
    const data = {
      fullname,
      email,
      password,
      phone: phoneForSubmission,
      city,
      role,
      ...(role === "admin" && {
        subMerchantType,
        iban,
        identityNumber,
        taxNumber,
      }),
    };

    axios
      .post(backendURL + "user/register", data)
      .then((response) => {
        if (response.data.success) {
          setPending((prev) => !prev);
          setIsErr(false);
          setShowAlert(true);
          setAlertMessage(
            "Kayıt başarılı! E-posta adresinize bir doğrulama bağlantısı gönderdik. Lütfen gelen kutunuzu kontrol edin ve hesabınızı aktifleştirmek için e-postanızı doğrulayın. Eğer doğrulama kodu gelmezse, hesabınıza giriş yaptıktan sonra menü üzerinden tekrar doğrulama kodu isteyebilirsiniz."
          );
          navigate("/giris-yap");
        } else {
          console.log(response);
          setPending((prev) => !prev);
          setIsErr(true);
          setShowAlert(true);
          setAlertMessage(response.data.message);
        }
      })
      .catch((err) => {
        setPending((prev) => !prev);
        console.log(err);
        setIsErr(true);
        setShowAlert(true);
        setAlertMessage(err.response.data.message);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 my-10">
      <div className="flex flex-col md:flex-row w-full max-w-6xl bg-white rounded-xl shadow-lg overflow-hidden">
        <img
          className="hidden md:block w-full h-auto max-w-[80%] md:max-w-[50%] object-contain rounded-t-xl md:rounded-t-none md:rounded-l-xl"
          src="/reduced-logo.webp"
          alt="Kayıt illüstrasyonu"
        />

        <div className="w-full md:w-1/2 p-8">
          <div className="flex items-center justify-center gap-2 mb-6">
            <h1 className="text-2xl font-extrabold tracking-tight">
              H
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                A
              </span>
              L
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                I
              </span>
              S
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                A
              </span>
              H
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                A
              </span>
              B
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                U
              </span>
              L
            </h1>
          </div>

          <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">
            Hesap Oluştur
          </h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label
                htmlFor="fullname"
                className="block text-sm font-medium text-gray-700"
              >
                Tam İsim <br />{" "}
                <p className="text-xs text-gray-500 italic">
                  Ödemelerde sorun yaşamamak için tam (isim ve soyisim) adınızı
                  girin.
                </p>
              </label>
              <input
                type="text"
                id="fullname"
                value={fullname}
                onChange={(e) => setFullname(e.target.value)}
                required
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
                placeholder="Tam isminizi girin"
              />
            </div>

            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                E-posta
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
                placeholder="E-postanızı girin"
              />
            </div>

            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700"
              >
                Telefon Numarası
              </label>
              <input
                type="tel"
                id="phone"
                value={phone}
                onChange={handlePhoneChange}
                required
                maxLength={12}
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
                placeholder="543 241 3664"
              />
            </div>

            <div>
              <label
                htmlFor="city"
                className="block text-sm font-medium text-gray-700"
              >
                Şehir
              </label>
              <input
                type="text"
                id="city"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
                placeholder="Şehrinizi girin"
              />
            </div>

            <div>
              <label
                htmlFor="role"
                className="block text-sm font-medium text-gray-700"
              >
                Hesap Türü
              </label>
              <select
                id="role"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors bg-white"
              >
                <option value="user">Normal</option>
                <option value="admin">Admin</option>
              </select>
            </div>

            {/* Admin-specific fields */}
            {role === "admin" && (
              <>
                <div>
                  <label
                    htmlFor="iban"
                    className="block text-sm font-medium text-gray-700"
                  >
                    IBAN
                  </label>
                  <input
                    type="text"
                    id="iban"
                    value={iban}
                    onChange={(e) => setIban(e.target.value)}
                    required={role === "admin"}
                    className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
                    placeholder="TRXX XXXX XXXX XXXX XXXX XX"
                  />
                </div>

                <div>
                  <label
                    htmlFor="identityNumber"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Kimlik Numarası
                  </label>
                  <input
                    type="text"
                    id="identityNumber"
                    value={identityNumber}
                    onChange={(e) => setIdentityNumber(e.target.value)}
                    required={role === "admin"}
                    className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
                    placeholder="Kimlik numaranızı girin"
                  />
                </div>

                <div>
                  <label
                    htmlFor="taxNumber"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Vergi Numarası
                  </label>
                  <input
                    type="text"
                    id="taxNumber"
                    value={taxNumber}
                    onChange={(e) => setTaxNumber(e.target.value)}
                    className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
                    placeholder="Vergi numaranızı girin (isteğe bağlı)"
                  />
                </div>
              </>
            )}

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700"
              >
                Şifre
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
                placeholder="Şifrenizi girin"
              />
            </div>

            <div>
              <label
                htmlFor="confirmPassword"
                className="block text-sm font-medium text-gray-700"
              >
                Şifreyi Onayla
              </label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
                placeholder="Şifrenizi onaylayın"
              />
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-2">
                <input
                  type="checkbox"
                  id="kvkk"
                  checked={acceptedKvkk}
                  onChange={(e) => setAcceptedKvkk(e.target.checked)}
                />
                <label
                  htmlFor="kvkk"
                  className="text-sm text-gray-700 cursor-pointer hover:underline"
                  onClick={() => setShowKvkkModal(true)}
                >
                  KVKK Aydınlatma Metni'ni okudum ve kabul ediyorum
                </label>
              </div>
              <div className="flex items-start gap-2">
                <input
                  type="checkbox"
                  id="terms"
                  checked={acceptedTerms}
                  onChange={(e) => setAcceptedTerms(e.target.checked)}
                />
                <label
                  htmlFor="terms"
                  className="text-sm text-gray-700 cursor-pointer hover:underline"
                  onClick={() => setShowTermsModal(true)}
                >
                  Kullanıcı Sözleşmesi'ni okudum ve kabul ediyorum
                </label>
              </div>
            </div>

            <button
              type="submit"
              className="w-full bg-[#4d9041] text-white py-2 rounded-md hover:bg-[#62a556] transition-colors duration-300 font-medium cursor-pointer"
            >
              Kaydol
            </button>
          </form>

          <p className="mt-4 text-center text-sm text-gray-600">
            Zaten bir hesabınız var mı?{" "}
            <Link
              to="/giris-yap"
              className="text-[#4d9041] hover:underline font-medium"
            >
              Buradan giriş yapın
            </Link>
          </p>
        </div>
      </div>
      <Dialog
        open={showKvkkModal}
        onClose={() => setShowKvkkModal(false)}
        className="fixed z-50 inset-0 overflow-y-auto"
      >
        <div className="flex items-center justify-center min-h-screen px-4">
          <Dialog.Panel className="bg-white rounded-lg shadow-xl p-6 max-w-xl w-full">
            <Dialog.Title className="text-xl font-bold mb-4">
              KVKK Aydınlatma Metni
            </Dialog.Title>
            <Dialog.Description className="text-sm text-gray-700 space-y-2 max-h-[60vh] overflow-y-auto">
              <p>
                2. KVKK Aydınlatma Metni
                <br />
                KİŞİSEL VERİLERİN KORUNMASI KANUNU (KVKK) AYDINLATMA METNİ
                <br />
                <br />
                6698 sayılı Kişisel Verilerin Korunması Kanunu uyarınca,
                HALISAHABUL olarak kişisel verilerinizi aşağıda açıklanan
                çerçevede işlemekteyiz.
                <br />
                <br />
                <strong>1. Veri Sorumlusu:</strong> HALISAHABUL
                <br />
                <br />
                <strong>2. İşlenen Veriler:</strong> Ad, soyad, e-posta adresi,
                telefon numarası, IP adresi, rezervasyon bilgileri, ödeme
                bilgileri (kart bilgileri hariç), cihaz ve oturum bilgileri
                <br />
                <br />
                <strong>3. İşleme Amaçları:</strong>
                <br />
                • Üyelik oluşturulması ve yönetilmesi
                <br />
                • Halı saha rezervasyon işlemlerinin gerçekleştirilmesi
                <br />
                • Sanal POS üzerinden ödeme işlemlerinin gerçekleştirilmesi
                <br />
                • Kullanıcı doğrulama ve güvenli giriş işlemlerinin sağlanması
                <br />
                • Müşteri hizmetlerinin sağlanması
                <br />
                • Mevzuattan doğan yükümlülüklerin yerine getirilmesi
                <br />
                • Hizmet kalitesinin artırılması ve kullanıcı deneyiminin
                iyileştirilmesi
                <br />
                <br />
                <strong>4. Aktarılan Taraflar:</strong> Yukarıdaki veriler,
                yalnızca rezervasyon yapılan saha işletmeleriyle, ödeme hizmet
                sağlayıcılarıyla (ödeme işlemlerinin gerçekleştirilmesi
                amacıyla) ve yasal yükümlülükler gereği yetkili mercilerle
                paylaşılabilir.
                <br />
                <br />
                <strong>5. Toplanma Yöntemi ve Hukuki Sebep:</strong>
                <br />
                Kişisel verileriniz, web sitemiz ve mobil uygulamamız üzerinden
                otomatik yollarla toplanmakta olup; KVKK’nın 5. ve 6. maddeleri
                uyarınca “sözleşmenin kurulması ve ifası”, “hukuki yükümlülük”,
                “meşru menfaat” ve gerektiğinde “açık rıza” hukuki sebeplerine
                dayanılarak işlenmektedir.
                <br />
                <br />
                <strong>6. Haklarınız:</strong>
                <br />
                KVKK’nın 11. maddesi uyarınca;
                <br />
                • Kişisel verilerinizin işlenip işlenmediğini öğrenme
                <br />
                • İşlenmişse buna ilişkin bilgi talep etme
                <br />
                • İşleme amacını ve amaca uygun kullanılıp kullanılmadığını
                öğrenme
                <br />
                • Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri
                bilme
                <br />
                • Eksik veya yanlış işlenmişse düzeltilmesini isteme
                <br />
                • KVKK kapsamında silinmesini veya yok edilmesini isteme
                <br />
                • Bu işlemlerin üçüncü kişilere bildirilmesini isteme
                <br />
                • İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla
                analiz edilmesi suretiyle aleyhinize bir sonucun ortaya
                çıkmasına itiraz etme
                <br />
                • Kanuna aykırı işleme nedeniyle zarara uğramanız hâlinde
                zararın giderilmesini talep etme haklarına sahipsiniz.
                <br />
                <br />
                <strong>İletişim:</strong>
                <br />
                Bu haklarınızı kullanmak için bizimle{" "}
                <a href="mailto:destek@halisahabul.com">
                  destek@halisahabul.com
                </a>{" "}
                e-posta adresinden iletişime geçebilirsiniz.
              </p>

              <p>
                Kişisel verileriniz; yasal yükümlülükler, kullanıcı doğrulama,
                rezervasyon işlemleri ve iletişim gibi amaçlarla kullanılabilir.
                Üçüncü taraflarla yalnızca yasal zorunluluklar veya hizmetin
                ifası amacıyla paylaşılır.
              </p>
            </Dialog.Description>
            <button
              onClick={() => setShowKvkkModal(false)}
              className="mt-4 px-4 py-2 bg-[#4d9041] text-white rounded hover:bg-[#62a556] cursor-pointer"
            >
              Kapat
            </button>
          </Dialog.Panel>
        </div>
      </Dialog>

      <Dialog
        open={showTermsModal}
        onClose={() => setShowTermsModal(false)}
        className="fixed z-50 inset-0 overflow-y-auto"
      >
        <div className="flex items-center justify-center min-h-screen px-4">
          <Dialog.Panel className="bg-white rounded-lg shadow-xl p-6 max-w-xl w-full">
            <Dialog.Title className="text-xl font-bold mb-4">
              Kullanıcı Sözleşmesi
            </Dialog.Title>
            <Dialog.Description className="text-sm text-gray-700 space-y-2 max-h-[60vh] overflow-y-auto">
              <p>
                <strong>1. Kullanıcı Sözleşmesi</strong>
                <br />
                İşbu Kullanıcı Sözleşmesi, HALISAHABUL tarafından sağlanan
                hizmetlerin kullanımına ilişkin koşulları düzenlemektedir.
                <br />
                Platforma üye olan her kullanıcı, bu sözleşmede yer alan hüküm
                ve şartlara tabi olduğunu kabul, beyan ve taahhüt eder.
              </p>

              <p>
                <strong>2. Hizmet Tanımı:</strong>
                <br />
                HALISAHABUL, kullanıcıların Türkiye genelinde halı saha kiralama
                işlemlerini çevrimiçi olarak yapabilmesini sağlayan bir dijital
                aracı platformdur. Rezervasyonlar, saha sahiplerinin onayıyla
                kesinleşir.
              </p>

              <p>
                <strong>3. Üyelik:</strong>
                <br />
                Platforma üye olabilmek için kullanıcının 18 yaşını doldurmuş
                olması ve doğru, eksiksiz bilgiler sunması gerekmektedir.
                <br />
                Kullanıcı hesabı kişiseldir; üçüncü kişilere devredilemez veya
                kullandırılamaz.
              </p>

              <p>
                <strong>4. Sorumluluklar:</strong>
                <br />
                • Kullanıcı, yaptığı rezervasyon işlemlerinde doğru ve güncel
                bilgi vermeyi kabul eder.
                <br />
                • Kullanıcı, halı saha kurallarına uymakla yükümlüdür.
                <br />
                • HALISAHABUL, sadece aracı hizmet sunduğundan; saha işletmeleri
                ile kullanıcılar arasındaki ihtilaflarda doğrudan taraf
                değildir.
                <br />• Platformun kötüye kullanımı, sahte rezervasyonlar veya
                ödeme ihlalleri durumunda hesap askıya alınabilir.
              </p>

              <p>
                <strong>5. Fesih:</strong>
                <br />
                HALISAHABUL, kullanıcı sözleşmesine aykırı davranan
                kullanıcıların üyeliğini askıya alma veya sona erdirme hakkını
                saklı tutar.
              </p>

              <p>
                <strong>6. Ödeme ve Rezervasyon:</strong>
                <br />
                • Ödemeler sanal POS altyapısıyla güvenli şekilde alınmaktadır.
                <br />
                • Rezervasyonlar, saha sahibinin onayıyla kesinleşir.
                <br />• Ödeme sonrası iptal ve değişiklik işlemleri, saha
                işletmesinin kurallarına tabidir.
              </p>

              <p>
                <strong>7. Gizlilik ve Veri Koruma:</strong>
                <br />
                Kullanıcının kişisel verileri, 6698 Sayılı KVKK kapsamında
                işlenmekte olup, detaylı bilgi için “Aydınlatma Metni”ne
                başvurulmalıdır.
              </p>

              <p>
                <strong>8. Değişiklik:</strong>
                <br />
                HALISAHABUL, bu sözleşme hükümlerinde dilediği zaman değişiklik
                yapma hakkını saklı tutar. Güncel metin, Platform’da
                yayımlandığı andan itibaren geçerli olur.
              </p>
            </Dialog.Description>
            <button
              onClick={() => setShowTermsModal(false)}
              className="mt-4 px-4 py-2 bg-[#4d9041] text-white rounded hover:bg-[#62a556] cursor-pointer"
            >
              Kapat
            </button>
          </Dialog.Panel>
        </div>
      </Dialog>
    </div>
  );
}

export default Register;
